<template>
  <form class="kt-form" data-vv-scope="item_quick_create_form" @submit.prevent="validateAndSubmit()">
    <item-storage-select v-model="storage_asset" />

    <div class="row">
      <div class="col-12">
        <hr>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="form-group kt-form__group">
          <label for="qc_item_name">{{ getItemLabel(true) }} Name <em>*</em></label>
          <input id="qc_item_name" v-model="name"
                 v-validate="'required'"
                 :name="`${getItemLabel(true)} Name`"
                 type="text"
                 class="form-control">
          <p v-show="errors.has(`${getItemLabel(true)} Name`, 'item_quick_create_form')" class="help kt-font-danger">
            {{ errors.first(`${getItemLabel(true)} Name`, 'item_quick_create_form') }}
          </p>
        </div>

        <div class="form-group kt-form__group">
          <label for="qc_description">Description</label>
          <tip-tap v-model="description" />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6">
        <div class="form-group kt-form__group row">
          <label class="col-md-4 col-form-label">Published</label>
          <div class="col-md-2">
            <span class="kt-switch kt-switch--icon">
              <label>
                <input v-model="published" type="checkbox"
                       :checked="published"
                       name="">
                <span />
              </label>
            </span>
          </div>
          <div class="col-12">
            <small>Publish schedules will override this value</small>
          </div>
        </div>
        <div class="m-form__group form-group">
          <ss-checkbox id="schedule-publish-dates" v-model="schedule_publish_dates">
            Schedule Publish Dates
          </ss-checkbox>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div v-if="schedule_publish_dates" class="m-form__group form-group">
          <label for="js-publish_start">Publish From</label>
          <datetime id="js-publish_start"
                    v-model="publish_start"
                    input-class="form-control kt-input"
                    type="datetime"
                    format="yyyy-MM-dd HH:mm:ss"
                    :zone="timezone" />
        </div>
        <div v-if="schedule_publish_dates && ! never_unpublish" class="m-form__group form-group">
          <label for="js-publish_stop">Publish Until</label>
          <datetime id="js-publish_stop"
                    v-model="publish_stop"
                    input-class="form-control kt-input"
                    type="datetime"
                    format="yyyy-MM-dd HH:mm:ss"
                    :min-datetime="min_publish_stop"
                    :zone="timezone" />
        </div>

        <div v-if="schedule_publish_dates" class="form-group">
          <ss-checkbox id="never-unpublish" v-model="never_unpublish">
            Never Unpublish
          </ss-checkbox>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6">
        <div class="form-group kt-form__group row">
          <label class="col-md-4 col-form-label">Downloadable</label>
          <div class="col-md-2">
            <span class="kt-switch kt-switch--icon">
              <label>
                <input v-model="downloadable" type="checkbox"
                       :checked="downloadable"
                       name="">
                <span />
              </label>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6 col-lg-4">
        <display-with-selection-modal :preselected-artwork="selected_artwork" @selected="(ev) => (selected_artwork = ev.selected_artwork)" />
      </div>
      <div class="col-12 col-md-6 col-lg-8">
        <label for="item_tags">{{ getItemLabel(true) }} Tags</label>
        <multiselect
          id="item_tags"
          v-model="ms_tag_values"
          :options="auto_complete_tags"
          :multiple="true"
          :taggable="true"
          track-by="uuid"
          label="name"
          placeholder="Search or add new tags..."
          @tag="addNewTag" />
      </div>
    </div>

    <div v-if="feeds && feeds.length" class="row">
      <div class="col-md-6">
        <label for="feed_select">Assign to {{ getFeedLabel(true) }}</label>
        <multiselect
          id="feed_select"
          v-model="selected_feed"
          :options="feeds"
          :placeholder="`Select a ${getFeedLabel(true)}`"
          label="name"
          track-by="name" />
      </div>
    </div>

    <div class="row no-gutters">
      <div class="col-12  no-gutters">
        <hr>
      </div>
    </div>

    <div class="row">
      <div class="col-12 text-right">
        <button class="btn btn-ss" type="submit" :disabled="!storage_asset || saving">
          <loader v-if="saving"
                  small
                  loading-text="Saving..."
                  class="mr-2" />Create {{ getItemLabel(true) }}
        </button>
        <button class="btn btn-ss-standout" type="submit"
                :disabled="!storage_asset || saving"
                @click="redirect = true">
          <loader v-if="saving"
                  small
                  loading-text="Saving..."
                  class="mr-2" />Create & View {{ getItemLabel(true) }}
        </button>
      </div>
    </div>
  </form>
</template>
<script>
import ItemPublishSettingsMixin from "VueMixins/ItemPublishSettingsMixin";
import DisplayWithSelectionModal from "VuePartials/Artwork/DisplayWithSelectionModal";
import ItemStorageSelect from "VueComponents/ItemCreation/ItemStorageSelect";
import TaggableModelMixin from 'VueMixins/TaggableModelMixin';

export default {
  components: {
    DisplayWithSelectionModal,
    ItemStorageSelect,
  },
  asyncComputed: {
    feeds: {
      async get() {
        return (await axios.get(`/api/v1/feeds`)).data.data;
      },
      default: [],
    },
  },
  mixins: [ItemPublishSettingsMixin, TaggableModelMixin],
  props: {
    preselectedStorageAsset: {
      type: Object,
      required: false,
      default: null,
    },
    preselectedFeed: {
      type: Object,
      required: false,
      default: null,
    },
    isClip: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      timezone: window.user.timezone,
      storage_asset: null,
      selected_artwork: null,
      name: null,
      description: null,
      downloadable: true,
      redirect: false,
      selected_feed: null,
      saving: false,
    };
  },
  computed: {
    min_publish_stop() {
      return moment(this.publish_start).add(1, 'hours').toISOString();
    },
  },
  beforeMount() {
    if (this.preselectedStorageAsset) {
      this.storage_asset = this.preselectedStorageAsset;
    }

    if (this.preselectedFeed) {
      this.selected_feed = this.preselectedFeed;
    }
  },
  mounted() {
    this.fetchTags();

    // Artwork selected from artwork modal
    EventBus.$on('new_artwork_selected', (payload) => {
      this.selected_artwork = payload;
    });
  },
  methods: {
    async validateAndSubmit() {
      this.saving = true; // activates button spinners
      const result = await this.$validator.validateAll('item_quick_create_form');
      if (result) {
        await this.submit();
      }
      this.saving = false;
    },
    async submit() {
      const data = {
        name: this.name,
        description: this.description,
        tags: this.ms_tag_values,
        artwork_uuid: this.selected_artwork?.uuid,
        published: this.published,
        asset_uuid: this.storage_asset.uuid,
        downloadable: this.downloadable,
        is_clip: this.isClip,
        feed_uuid: this.selected_feed?.uuid,
      };

      if (this.schedule_publish_dates) {
        data.publish_start = this.publish_start;
        data.publish_stop = this.publish_stop;
      }

      try {
        const response = await axios.post("/api/v1/items/quick-create", data);
        if (this.redirect) {
          toastr.success("Item Created. Redirecting...");
          window.location.href = `/items/${response.data.data.uuid}/edit`;
        } else {
          this.$modal.hide('item-create-modal');
          this.reloadTables();
          toastr.success("Item Created.");
        }
        this.gtmEventPush({
          'event': 'item_created',
          'item_data': data,
        });
      } catch (err) {
        window.handleAxiosError(err);
      }
    },
    reloadTables() {
      // Items can be created from item table
      EventBus.$emit(`items-table-reload`);
      // Items can be created by converting a clip to an item. The clip should be removed from the table afterwards.
      EventBus.$emit(`clips_table`);
      // Items can be created from a storage asset, this will create a new storage asset based on item name.
      EventBus.$emit(`storage-table`);
    },
  },
};
</script>
